
import React from 'react';
import { useLocation } from 'react-router-dom';
import RouteGuard from '@/components/routing/RouteGuard';
import NavigationErrorBoundary from '@/components/navigation/NavigationErrorBoundary';

interface RouteManagerProps {
  children: React.ReactNode;
}

const RouteManager: React.FC<RouteManagerProps> = ({ children }) => {
  const location = useLocation();

  return (
    <NavigationErrorBoundary>
      <RouteGuard>
        {children}
      </RouteGuard>
    </NavigationErrorBoundary>
  );
};

export default RouteManager;
